"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createChatEventCallbacks = createChatEventCallbacks;
var context_1 = require("../context");
function createChatEventCallbacks(contextRef) {
    return {
        ai_cancel_modal_cancel_clicked: function () {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('ai_cancel_modal_cancel_clicked', __assign({}, (0, context_1.buildInChatContextProperties)(ctx)));
        },
        ai_cancel_modal_engaged: function () {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('ai_cancel_modal_engaged', __assign({}, (0, context_1.buildInChatContextProperties)(ctx)));
        },
        ai_cancel_modal_viewed: function () {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('ai_cancel_modal_viewed', __assign({}, (0, context_1.buildInChatContextProperties)(ctx)));
        },
        ai_conversation_deleted: function () {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('ai_conversation_deleted', __assign(__assign({}, (0, context_1.buildInChatContextProperties)(ctx)), { ui_element: 'Conversation List' }));
        },
        ai_conversation_favorited: function () {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('ai_conversation_favorited', __assign(__assign({}, (0, context_1.buildInChatContextProperties)(ctx)), { ui_element: 'Conversation List' }));
        },
        ai_conversation_name_updated: function () {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('ai_conversation_name_updated', __assign(__assign({}, (0, context_1.buildInChatContextProperties)(ctx)), { ui_element: 'Conversation List' }));
        },
        ai_conversation_opened: function () {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('ai_conversation_opened', __assign(__assign({}, (0, context_1.buildInChatContextProperties)(ctx)), { ui_element: 'Conversation List' }));
        },
        ai_conversation_resumed: function (inputMethod, uiElement) {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('ai_conversation_resumed', __assign(__assign({}, (0, context_1.buildInChatContextProperties)(ctx)), { input_method: inputMethod, ui_element: uiElement }));
        },
        ai_conversation_started: function (inputMethod, uiElement) {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('ai_conversation_started', __assign(__assign({}, (0, context_1.buildInChatContextProperties)(ctx)), { input_method: inputMethod, ui_element: uiElement }));
        },
        ai_conversation_unfavorited: function () {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('ai_conversation_unfavorited', __assign(__assign({}, (0, context_1.buildInChatContextProperties)(ctx)), { ui_element: 'Conversation List' }));
        },
        ai_error_response: function (errorDetails, inputMethod, uiElement) {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('ai_error_response', __assign(__assign({}, (0, context_1.buildInChatContextProperties)(ctx)), { error_details: errorDetails, input_method: inputMethod, ui_element: uiElement }));
        },
        ai_message_failure: function (errorDetails, inputMethod, uiElement) {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('ai_message_failure', __assign(__assign({}, (0, context_1.buildInChatContextProperties)(ctx)), { error_details: errorDetails, input_method: inputMethod, ui_element: uiElement }));
        },
        ai_message_received: function (messagePairId, messageLength, inputMethod) {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('ai_message_received', __assign(__assign({}, (0, context_1.buildInChatContextProperties)(ctx)), { message_pair_id: messagePairId, message_length: messageLength, input_method: inputMethod, ui_element: 'Text' }));
        },
        ai_message_sent: function (message, inputMethod, submissionMethod) {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            var playbackState = inputMethod === 'Text' ? ctx.getPlaybackState() : null;
            ctx.posthogClient.capture('ai_message_sent', __assign(__assign(__assign(__assign({}, (0, context_1.buildInChatContextProperties)(ctx)), { message_length: Array.from(message).length, input_method: inputMethod }), (submissionMethod && { submission_method: submissionMethod })), ((playbackState === null || playbackState === void 0 ? void 0 : playbackState.currentTimeSeconds) != null && {
                video_time_seconds: playbackState.currentTimeSeconds,
            })));
        },
        ai_module_clicked: function (uiElement) {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('ai_module_clicked', __assign(__assign({}, (0, context_1.buildInChatContextProperties)(ctx)), { ui_element: uiElement }));
        },
        ai_module_closed: function (sessionDurationMs, uiElement, method) {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('ai_module_closed', __assign(__assign(__assign({}, (0, context_1.buildInChatContextProperties)(ctx)), { session_duration_ms: sessionDurationMs, ui_element: uiElement }), (method && { method: method })));
        },
        ai_module_opened: function (uiElement, isInitial) {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('ai_module_opened', __assign(__assign(__assign({}, (0, context_1.buildInChatContextProperties)(ctx)), { ui_element: uiElement }), (isInitial !== undefined && { is_initial: isInitial })));
        },
        ai_module_viewed: function (uiElement) {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('ai_module_viewed', __assign(__assign({}, (0, context_1.buildInChatContextProperties)(ctx)), { ui_element: uiElement }));
        },
        ai_navigation_clicked: function () {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('ai_navigation_clicked', __assign({}, (0, context_1.buildInChatContextProperties)(ctx)));
        },
        ai_page_view_chat_home: function () {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('ai_page_view_chat_home', __assign({}, (0, context_1.buildInChatContextProperties)(ctx)));
        },
        ai_persona_selected: function (aiPersona) {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('ai_persona_selected', __assign(__assign({}, (0, context_1.buildInChatContextProperties)(ctx)), { ai_persona: aiPersona }));
        },
        ai_rate_limited: function () {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('ai_rate_limited', __assign({}, (0, context_1.buildInChatContextProperties)(ctx)));
        },
        ai_recommendation_clicked: function (payload) {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('ai_recommendation_clicked', __assign(__assign({}, (0, context_1.buildInChatContextProperties)(ctx)), payload));
        },
        ai_recommendation_received: function () {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('ai_recommendation_received', __assign({}, (0, context_1.buildInChatContextProperties)(ctx)));
        },
        ai_recommendation_viewed: function (payload) {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('ai_recommendation_viewed', __assign(__assign({}, (0, context_1.buildInChatContextProperties)(ctx)), payload));
        },
        ai_message_regenerated: function (uiElement) {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('ai_message_regenerated', __assign(__assign({}, (0, context_1.buildInChatContextProperties)(ctx)), { input_method: 'Prompt', ui_element: uiElement }));
        },
        ai_message_feedback: function (uiElement) {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('ai_message_feedback', __assign(__assign({}, (0, context_1.buildInChatContextProperties)(ctx)), { ui_element: uiElement }));
        },
        ai_speech_to_text: function () {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('ai_speech_to_text', __assign(__assign({}, (0, context_1.buildInChatContextProperties)(ctx)), { input_method: 'Speech', ui_element: 'Voice Mode' }));
        },
        ai_unrecognized_input: function (errorDetails, inputMethod, uiElement) {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('ai_unrecognized_input', __assign(__assign({}, (0, context_1.buildInChatContextProperties)(ctx)), { error_details: errorDetails, input_method: inputMethod, ui_element: uiElement }));
        },
        ai_videoguide_disabled: function () {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('ai_videoguide_disabled');
        },
        ai_videoguide_enabled: function () {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('ai_videoguide_enabled');
        },
        concept_moment_toast_shown: function (momentStartSeconds, conceptLabel) {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('concept_moment_toast_shown', __assign(__assign({}, (0, context_1.buildInChatContextProperties)(ctx)), { moment_start_seconds: momentStartSeconds, concept_label: conceptLabel, video_time_seconds: ctx.getPlaybackState().currentTimeSeconds }));
        },
        concept_moment_toast_clicked: function (momentStartSeconds, conceptLabel) {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('concept_moment_toast_clicked', __assign(__assign({}, (0, context_1.buildInChatContextProperties)(ctx)), { moment_start_seconds: momentStartSeconds, concept_label: conceptLabel, video_time_seconds: ctx.getPlaybackState().currentTimeSeconds }));
        },
        concept_moment_toast_dismissed: function (momentStartSeconds, conceptLabel) {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('concept_moment_toast_dismissed', __assign(__assign({}, (0, context_1.buildInChatContextProperties)(ctx)), { moment_start_seconds: momentStartSeconds, concept_label: conceptLabel, video_time_seconds: ctx.getPlaybackState().currentTimeSeconds }));
        },
    };
}
